export default __webpack_public_path__ + "static/media/chart-arrow-grow.7fe77022.svg";